import changeCaseObject from 'change-case-object'
import {
  STREAM_NOTIFICATIONS_REQUEST,
  STREAM_NOTIFICATIONS_SUCCESS,
  STREAM_NOTIFICATIONS_FAILURE
} from './actionTypes'

import getstream from 'getstream'

import { selectCurrentHomeUser } from 'src/store/selectors/home'

const USER_HOME_FEED = 'user_home'

const client = getstream.connect(
  process.env.REACT_APP_GETSTREAM_API_KEY,
  null,
  process.env.REACT_APP_GETSTREAM_API_APP
)

export const getHomeNotifications = (token, markSeen = false) => async (
  dispatch,
  getState
) => {
  const { homeRef, tokenValue } = token
  const homeowner = selectCurrentHomeUser(getState())

  if (!homeowner) {
    return
  }

  dispatch({
    type: STREAM_NOTIFICATIONS_REQUEST,
    token
  })

  try {
    const feed = client.feed(
      USER_HOME_FEED,
      `${homeowner.id}_${homeRef}`,
      tokenValue
    )

    const { results } = await feed.get({ limit: 5, mark_seen: markSeen })
    dispatch({
      type: STREAM_NOTIFICATIONS_SUCCESS,
      token,
      notifications: changeCaseObject.camelCase(results)
    })
  } catch (error) {
    dispatch({
      type: STREAM_NOTIFICATIONS_FAILURE,
      token,
      error
    })
  }
}

export const getHomeNotificationsIfNeeded = token => (dispatch, getState) => {
  const { streamNotifications } = getState()

  if (streamNotifications[token.homeRef]) {
    return
  }

  return dispatch(getHomeNotifications(token))
}
